import { Box, Stack, useMediaQuery } from '@mui/material'
import { styled } from '@mui/system'

export const StyledPageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  position: 'fixed',
  top: '0px',
  left: '0px',
  backgroundColor: theme.palette.background.main,
  color: theme.palette.text.base,
  overflow: 'hidden',
  '& .MuiBox-root': {
    tabIndex: -1,
  },
}))

export const StyledPageContentContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(4),
  paddingTop: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: useMediaQuery(theme.breakpoints.down('sm')) ? theme.spacing(1.5) : theme.spacing(2),
  overflowY: 'auto',
  scrollbarGutter: 'stable',
}))

export const StyledPageContent = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: '100%',
  paddingLeft: useMediaQuery(theme.breakpoints.down('sm')) ? theme.spacing(0) : theme.spacing(2),
  paddingRight: useMediaQuery(theme.breakpoints.down('sm')) ? theme.spacing(0) : theme.spacing(2),
  color: theme.palette.text.base,
}))

export const StyledPageContentFlexCol = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  padding: '0 1rem 0 1rem',
}))

export const StyledPageSectionRow = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingBottom: theme.spacing(3),
  gap: theme.spacing(3),
}))